import { FORM_TYPES } from '../consts';

export const getFlowType = (formType: string) => {
  return formType === FORM_TYPES.DIRECTBUY ? FORM_TYPES.PURCHASE : FORM_TYPES.TRIAL.toLowerCase();
};

export const getFlowTypePayload = (formType: string) => {
  const params = new URLSearchParams(window.location.search);
  let isMax = params.has('max');
  if (isMax) {
    return formType === FORM_TYPES.DIRECTBUY ? 'business_max_purchase' : 'business_max_trial';
  }
  return formType === FORM_TYPES.DIRECTBUY ? FORM_TYPES.PURCHASE : FORM_TYPES.TRIAL.toLowerCase();
};
